import Marquee from "react-fast-marquee";

const WORDS = ["Residential", "End of Lease", "Commercial", "Carpet Steam", "Deep Clean", "Eco-Friendly", "Bond Back", "Office"];

export default function EditorialMarquee({ dark = false }) {
  return (
    <div data-testid="marquee" className={`py-8 border-y ${dark ? "bg-[#1C2A39] border-white/10" : "bg-[#E8F1EB] border-[#d6e6dc]"}`}>
      <Marquee speed={38} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className={`font-display font-medium text-4xl sm:text-6xl px-8 ${dark ? "text-white" : "text-[#1C2A39]"}`}>{w}</span>
            <span className="text-[#0D9488] text-4xl sm:text-6xl">✦</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
}
